
export default function routes($stateProvider) {
	$stateProvider
		.state('loginPage', {
			url: '/?redirect',
			template: require('./login.html'),
			resolve: {
				credentials: ['User', function (User) {
					return User.getCredentials();
				}],
			},
			controller: 'LoginController',
			controllerAs: 'login'
		});
}

routes.$inject = ['$stateProvider'];



// WEBPACK FOOTER //
// ./src/page/login/login.routes.js